<template>
<div class="main">
	<Steps :index="1" :product-name="info.productName||''" />
	<slot :info="info" name="recognizeInfo"></slot>
	<ApplicantInfo :info="info.applicantInfo" :upload-file-list="applicantUploadFileList" class="mt20"/>
	<InvoiceInfo :info="info.invoiceInfo" :type="info.applicantInfo.identityType"/>
	<div class="mt15 agree">
		<Checkbox v-model="agree">我已经阅读并同意</Checkbox>
		<slot name="agree"></slot>
	</div>
	<div class="mt20 center">
		<p>实际支付：<span class="price">{{info.premium||''}}元</span></p>
		<p class="mt10">
			<Button type="primary" @click="toPay" :disabled="!agree" :loading="loading">立即支付</Button>
		</p>
	</div>
</div>
</template>
<script>
import ApplicantInfo from './ApplicantInfo'
import InvoiceInfo from './InvoiceInfo'
import Steps from './Steps'
import {applicantUploadFileMap} from '@/pages/haierProduct/common/dictionary'
import track from "@/mixin/track";
export default {
	mixins:[track],
	components:{ 
		ApplicantInfo,
		InvoiceInfo,
		Steps },
	data () {
		return {
			info:{
				applicantInfo:{},
				subjectMatter:[],
				subjectMatterUrls:'',
				invoiceInfo:{
					invoiceType:'NOT'
				}
			},
			loading:false,
			agree:false,
			id:this.$route.params.id
		}
	},
	computed: {
		applicantUploadFileList(){
			let list=applicantUploadFileMap[this.info.productCode]
			if(list){
				return list.filter(item=>{
					return item.identityType==this.info.applicantInfo.identityType
				})
			}
			return []
		},
	},
	created(){
		if(this.id){
			this.getInfo()
		}
	},
	mounted () {
		// 回溯 开始录制
		this.$nextTick(this.startRecord);
	},
	methods:{
		// 根据id获取信息
		getInfo(){
			let url = this.$route.params.type=='person'?'/broker/insurance/application/detail.dst':'/broker/insurance/application/detail'
			this.$axios.post(url,{
				applicationId:this.id
			}).then(res=>{
				this.info=res
				this.info.applicantInfo=res.applicantList&&res.applicantList.length>0?res.applicantList[0]:{}
			});
		},
		toPay () {
			this.loading=true;
			this.$axios.post('/broker/insurance/application/confirm',{
				applicationId:this.id,
			}).then(async res=>{
				this.loading = false;
				console.log(this.info,'chakan')
				// 回溯 停止录制
				await this.stopRecord({
					session_key:sessionStorage.track_session_key,
					policy_id:this.info.applicationNo
				});
				window.location.href=`/common.html#/common-pay/${res}`
			}).catch(res=>{
				this.loading = false;
			});
		}
	}
}
</script>
<style scoped lang="less">
	.main{
		background: #fff;
		margin-top: 15px;
		padding :30px 40px;
	}
	.mt20{
		font-size: 25px;
		line-height: 1.8;
	}
	span.price{
		color:#FF0000;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/ConfirmContainer.vue